import './AiAssistantWaveformIcon.css';

import aiAssistantWaveformConfig from '../../../consts/aiAssistant/aiAssistantWaveformConfig';
import useAiAssistantWaveform from '../../../hooks/useAiAssistantWaveform';
import aiAssistantWaveformMotionService from '../../../services/aiAssistant/aiAssistantWaveformMotionService';
import {twx} from '../../../utils/tailwindUtils';
import Icon from '../Icon';

const {WIDTH, HEIGHT, STRANDS, SOFTEN, BLOOM, BLOOM_GAIN} = aiAssistantWaveformConfig;

const STRANDS_ID = 'ai-assistant-waveform-strands';

// Initial pose before the loop starts, and the only one under prefers-reduced-motion
const REST_FRAME = aiAssistantWaveformMotionService.getWaveformFrame(0);

// Opacity caps at 1, so a gain of 1.4 is drawn as two bloom layers: 1 and 0.4
const BLOOM_OPACITIES = [1, BLOOM_GAIN - 1];

// Blur in viewBox units, converted to cqw so it scales with the icon
const Layer = ({blur, className, style, children}) => (
    <Icon
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        fill='none'
        className={twx('ai-assistant-waveform__layer absolute inset-0 h-full w-full', className)}
        style={{filter: `blur(${(blur / WIDTH) * 100}cqw)`, ...style}}
    >
        {children}
    </Icon>
);

// CSS blur, not an SVG filter: WebKit clipped the filter's glow and left trails of old frames
const AiAssistantWaveformIcon = ({className}) => {
    const strandsRef = useAiAssistantWaveform();

    return (
        <div
            className={twx('ai-assistant-waveform relative isolate', className)}
            style={{width: WIDTH, aspectRatio: `${WIDTH} / ${HEIGHT}`}}
        >
            <Layer blur={SOFTEN}>
                <g id={STRANDS_ID} ref={strandsRef}>
                    {STRANDS.map(({color}, index) => (
                        <path key={color} d={REST_FRAME[index]} fill={color} style={{mixBlendMode: 'plus-lighter'}} />
                    ))}
                </g>
            </Layer>

            {BLOOM_OPACITIES.map((opacity) => (
                <Layer key={opacity} blur={BLOOM} className='mix-blend-plus-lighter' style={{opacity}}>
                    <use href={`#${STRANDS_ID}`} />
                </Layer>
            ))}
        </div>
    );
};

export default AiAssistantWaveformIcon;
